import { render, staticRenderFns } from "./email-editor.vue?vue&type=template&id=222993cd&"
import script from "./email-editor.vue?vue&type=script&lang=js&"
export * from "./email-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports